<template>
  <div
    v-if="complementary"
    class="section-observations h-100"
  >
    <div class="h-100 d-flex flex-column justify-content-between">
      <div class="d-flex flex-column flex-grow-1">
        <b-row class="d-flex align-items-center mb-2 mt-1">
          <b-col>
            <span class="ap-title ap-title__main">{{ $t('diagnosis.sections.observations') }}</span>
          </b-col>
          <b-col
            cols="auto"
            class="d-flex justify-content-end"
          >
            <b-button
              v-tooltip="$t('global.description.clear')"
              qa="section-complementary-observations-clear-text-button"
              :disabled="disabled"
              class="btn__icon btn__icon--primary  px-2"
              @click="cleanComplementaryObservationText"
            >
              <i
                class="far fa-eraser"
                aria-hidden="true"
              />
            </b-button>
          </b-col>
        </b-row>
        <b-row class="diagnosis-layout-height flex-grow-1">
          <b-col>
            <b-form-textarea
              ref="complementaryObservationsTextArea"
              v-model="complementaryObservation"
              qa="section-complementary-observations-textarea"
              class="w-100 observations-textarea"
              no-resize
              :disabled="disabled"
            />
          </b-col>
        </b-row>
      </div>
      <div class="d-flex justify-content-end">
        <vt-loading-button
          qa="section-complementary-observations-save-button"
          :disabled="!!complementary.validationDate"
          class="btn__outline btn-sm mt-2"
          :params="{ promise: save, shortkeys: ['alt', 's'] }"
        >
          <i
            class="fal fa-save mr-2"
            aria-hidden="true"
          />
          {{ $t('global.save') }}
        </vt-loading-button>
      </div>
    </div>
  </div>
</template>

<script>
import complementaryServices from '@/modules/diagnosisModule/services/complementaryServices'
import { cloneDeep, isEqual } from 'lodash'
export default {
    name: 'ObservationsSection',
    props: {
        labId: { type: Number, required: true },
        complementaryId: { type: Number, required: true },
        casId: { type: Number, required: true }
    },
    data() {
        return {
            complementaryObservation: null,
            originalComplementaryObservation: null,
            complementary: null
        }
    },
    computed: {
        disabled() {
            return !!this.complementary.validationDate
        }
    },
    async mounted() {
        await this.loadObservation()
        const complementaryObservationTextLength = this.complementaryObservation?.length
        this.$_moveInputElementCaretToEnd(this.$refs.complementaryObservationsTextArea, complementaryObservationTextLength)
    },
    methods: {
        async loadObservation() {
            this.updateLoading(true)
            const [err, response] = await this.toCall(complementaryServices.getComplementaryById(this.labId, this.casId, this.complementaryId))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.complementary = response
            this.complementaryObservation = response.observations
            this.originalComplementaryObservation = cloneDeep(response.observations)
            this.$emit('reloadSummary')
        },
        hasBeenChanged() {
            return !isEqual(this.complementaryObservation, this.originalComplementaryObservation)
        },
        async save() {
            const observation = {
                observations: this.complementaryObservation,
                samId: this.complementary.sampleId,
                responsibleId: this.complementary.responsible ? this.complementary.responsible.id : null,
                originalConcurrencyUpdatedAt: this.complementary.originalConcurrencyUpdatedAt
            }
            this.updateLoading(true)
            const [err] = await this.toCall(complementaryServices.updateComplementary(this.labId, this.casId, this.complementaryId, observation))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return false
            }
            this.showToastSuccessGlobal()
            await this.loadObservation()
            return true
        },
        cleanComplementaryObservationText() {
            this.complementaryObservation = ''
        }
    }
}
</script>

<style lang="scss">
.section-observations .ql-toolbar.ql-snow {
  padding: 2px;
}

.section-observations .ql-editor {
  height: calc(100vh - 365px);
  transition: 0.35s;
  overflow-y: auto;
}

/*--Styles for large screen--*/
@media (max-width: 1300px) {
  .section-observations .ql-editor {
  height: calc(100vh - 380px);
}
}

</style>
